export default __webpack_public_path__ + "static/media/Savant's Tunic of the Effulgent Blade.fe592908.jpg";